import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IAlert } from '../../interfaces/alert';
import { AlertService } from '../../services/alert.service';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  imports: [NgbAlertModule],
  styleUrl: './alert.component.scss',
})
export class AlertComponent {
  @Input({ required: false }) alert: IAlert = new IAlert();
  @Output() close: EventEmitter<IAlert> = new EventEmitter<IAlert>();

  constructor(
    private alertService: AlertService,

  ) {}

  public closeAlert() {
    this.close.next(this.alert);
    this.alertService.removeAlert(this.alert);
  }

  public getAlertIcon() {
    switch (this.alert.type) {
      case 'success':
        return 'check';
      case 'danger':
        return 'x';

      default:
        return this.alert.type;
    }
  }
}
